// extracted by mini-css-extract-plugin
export default {"dialog":"FyKRDXxtG4RNOdr7","body":"HUxf4l6aVws4bD8T","header":"Ep_U6b8haEX2XvHy","title":"l6QTXXM7opklNxFK","subTitle":"T20RbYYVqV0fTIF2"};